"use client"
import React from 'react'
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';
import { formatDateShort } from '@/app/helpers';
import { useTheme } from '@/app/theme-provider';


const Legaladvisor = () => {
    const{language}=useTheme()
    //  const [page, setPage] = useState(1);
    const { data: list, loading, error } = useFetch(
        "/website/wings-legal-wings/legaladvisor",
        // { page, limit: 5 }, // pass page & limit here
        []
    );


    return (
        <>
            <div className='row'>
                <div className='col'>
                    <div className='directorate-main'>
                        <h4>{language=="en"?"LEGAL WING":"നിയമപരമായ വിഭാഗം"}</h4>
                        <p>{language=="en"?"This Bureau has its own Legal Wing to conduct the prosecution of Cases in the six Special Courts and to attend to the work in the two Vigilance Tribunals on behalf of the State. The legal wing consists of one Additional Director of Prosecution, 5 Legal Advisers  and 8 Public Prosecutors. The Legal Wing also furnishes legal opinion in Enquiries/Investigations undertaken by this Bureau.":"ആറ് പ്രത്യേക കോടതികളിലെ കേസുകളുടെ പ്രോസിക്യൂഷൻ നടത്തുന്നതിനും സംസ്ഥാനത്തിനുവേണ്ടി രണ്ട് വിജിലൻസ് ട്രൈബ്യൂണലുകളിലെ ജോലികൾ കൈകാര്യം ചെയ്യുന്നതിനും ഈ ബ്യൂറോയ്ക്ക് സ്വന്തമായി ഒരു നിയമ വിഭാഗം ഉണ്ട്. നിയമ വിഭാഗത്തിൽ ഒരു അഡീഷണൽ ഡയറക്ടർ ഓഫ് പ്രോസിക്യൂഷൻ, 5 നിയമ ഉപദേഷ്ടാക്കൾ, 8 പബ്ലിക് പ്രോസിക്യൂട്ടർമാർ എന്നിവർ ഉൾപ്പെടുന്നു. ഈ ബ്യൂറോ നടത്തുന്ന അന്വേഷണങ്ങൾ/അന്വേഷണങ്ങളിൽ നിയമ അഭിപ്രായം നൽകുന്നതും നിയമ വിഭാഗമാണ്."}</p>
                    </div>
                </div>
            </div>
            <div className='row g-3 g-lg-4 mt-1'>
                {list?.length > 0 ? (
                    <>
                        {list?.map((item, index) => (
                            <>
                                <div key={index} className='col-md-6'>
                                    <div className='mision-card h-100'>
                                        <h4>{item.name}</h4>
                                        <p>{item?.details}</p>
                                        <div className='ph-email'>
                                            <p>  <IoCall style={{ color: "#ff9500" }} /> {item?.phone}</p>
                                            <a style={{ color: "#ccc" }} href={`mailto:${item.email}`} className='mx-0 mx-lg-3'><MdEmail style={{ color: "#ff9500" }} /> {item.email}</a>
                                        </div>

                                    </div>
                                </div>
                            </>
                        ))}
                    </>
                ) : <>
                    <h4>No data found</h4>
                </>}


            </div>
        </>
    )
}

export default Legaladvisor
